import { Recipient, TemplateResponse } from "@accurx/api/content";
import { Ds } from "@accurx/design";
import { SkeletonLoader } from "@accurx/inbox-design-library";
import { useMessageTemplates } from "@accurx/message-templates";
import {
    StyledFetchingError,
    StyledReloadButton,
} from "domains/message-component/components/Compose/components/MessageTemplates/Templates.styles";
import { TemplatesBrowser } from "domains/message-component/components/Compose/components/MessageTemplates/components/TemplatesBrowser/TemplatesBrowser";
import { TemplateItem } from "domains/message-component/types";

type ClinicianTemplatesProps = {
    workspaceId: number;
};
export const ClinicianTemplates = ({
    workspaceId,
}: ClinicianTemplatesProps) => {
    const { data, status, refetch } = useMessageTemplates(workspaceId, {
        recipient: Recipient.HealthcareProfessional,
    });

    if (status === "loading") {
        return <SkeletonLoader width="100%" height="20px" />;
    }

    if (status === "error") {
        return (
            <StyledFetchingError>
                <Ds.Flex alignItems={"center"}>
                    <Ds.Icon size="xsmall" name="Error" appearance="solid" />
                </Ds.Flex>
                <Ds.Text size="small" color="zinc">
                    Templates failed to load.
                </Ds.Text>
                <StyledReloadButton onClick={() => void refetch()}>
                    Reload templates
                </StyledReloadButton>
            </StyledFetchingError>
        );
    }

    const mapTemplates = (
        templateResponse: TemplateResponse[],
    ): TemplateItem[] =>
        templateResponse.map((template) => {
            return {
                type: "MessageTemplate",
                value: {
                    id: template.id,
                    title: template.title,
                    body: template.body + "\n", // Add a new line so there's space between the body and signature
                    owner: "Accurx",
                    heading: template.category,
                    allowReplyByDefault: false,
                },
            };
        });

    return (
        <TemplatesBrowser
            templates={mapTemplates(data.templates)}
            patientExternalIds={[]}
        />
    );
};
